export var AuthError;
(function (AuthError) {
    AuthError["UNKNOWN_USER"] = "unknown_user";
    AuthError["DUPLICATE_SIGNIN"] = "duplicate_signin";
    AuthError["SESSION_EXPIRED"] = "session_expired";
    AuthError["INVALID_AUTH_TOKEN"] = "invalid_auth_token";
    AuthError["ISSUE_AUTH_TOKEN_FAILED"] = "issue_auth_token_failed";
    AuthError["RETRIEVE_USER_DATA_FAILED"] = "retrieve_user_data_failed";
    AuthError["CREATE_WALLET_FAILED"] = "create_wallet_failed";
    AuthError["SAVE_WALLET_FAILED"] = "save_wallet_failed";
    AuthError["UNSUPPORTED_BROWSER"] = "unsupported_browser";
    AuthError["INVALID_LINK"] = "auth/invalid-action-code";
})(AuthError || (AuthError = {}));
